import React from "react";

import ModalSection from "@hl/base-components/lib/modal/ModalSection";
import {
  Button,
  Box,
  TextInput,
  Stack,
  Text,
  Flex,
  Loader,
  Center,
} from "@mantine/core";
import { useInputState } from "@mantine/hooks";

import { Condition, ConditionType } from "apollo/graphql.generated";

import {
  useGetFarcasterUserQuery,
  useSearchFarcasterUserLazyQuery,
} from "../../queries/farcaster.graphql.generated";

export type SetAllowlistProps = {
  onSave: (data: Condition) => void;
  submitText?: string;
  initialCondition?: Condition;
};

const SetFarcasterState = ({
  onSave,
  submitText = "Save",
  initialCondition,
}: SetAllowlistProps) => {
  const followFID = initialCondition?.data?.followFID ?? "";

  const [searchUsername, setSearchUsername] = useInputState("");
  const [searchFcUser, { data: searchData, loading: searchLoading }] =
    useSearchFarcasterUserLazyQuery();
  const searchByUsername = () => {
    searchFcUser({ variables: { username: searchUsername } });
  };

  const { data, loading } = useGetFarcasterUserQuery({
    variables: {
      fid: parseInt(followFID!),
    },
    skip: !followFID,
  });

  const foundUser = searchData?.farcasterUserSearch;
  const user = foundUser ?? data?.farcasterUser;
  const notFound = foundUser === null;
  const changedUsername = !!searchUsername;

  const addOrUpdateCondition = () => {
    if (!user?.fid) {
      return;
    }
    onSave({
      data: {
        followFID: user.fid.toString(),
      },
      type: ConditionType.FARCASTER,
    });
  };

  if (loading) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }

  return (
    <>
      <Box>
        <Text mb="lg">
          To unlock this gate users must follow specified Farcaster account
        </Text>
        <Flex align="flex-end" gap="md">
          <TextInput
            label="Farcaster username"
            placeholder="username"
            onChange={setSearchUsername}
            defaultValue={user?.username}
            sx={{ flex: 2 }}
          />
          <Button onClick={searchByUsername} mb={8} disabled={!searchUsername}>
            Search
          </Button>
        </Flex>
        {searchLoading ? (
          <Center mt="lg">
            <Loader size="sm" />
          </Center>
        ) : notFound ? (
          <Center pt="lg">
            <Text size="sm">Not Found</Text>
          </Center>
        ) : (
          user &&
          (!changedUsername || foundUser) && (
            <Stack mt="lg">
              <Text size="sm">
                Display Name: <b>{user.displayName}</b>
              </Text>
              <Text size="sm">
                Followers: <b>{user.followerCount}</b>
              </Text>
              <Text size="sm">
                FID: <b>{user.fid}</b>
              </Text>
            </Stack>
          )
        )}
        <ModalSection>
          <Button
            size="xl"
            fullWidth
            onClick={addOrUpdateCondition}
            disabled={!user || followFID == (user?.fid ?? 0).toString()}
          >
            {submitText}
          </Button>
        </ModalSection>
      </Box>
    </>
  );
};

export default SetFarcasterState;
